<template>
  <div class="page-wrapper">

    <div class="background-page">


      <transition name="slide-fade">
        <div class="background-page level-2"  style="overflow-y: scroll; background:white;" v-if="currentMerchantItem != false" v-on:scroll="handleScroll" id="menu-page">
          <div class="container fixed-top " style="background:white;" id="restaurant-panel">

            <div class="restaurant-image">
              <slider animation="fade" style="height:200px">
                <slider-item
                  v-for="(img, index) in images"
                  :key="index"
                  style="z-index: 0; height:200px;"


                >
                  <div class="restaurant-image" v-bind:style="{backgroundImage: 'url(' + img + ')'}"></div>
                </slider-item>
              </slider>
              <div class="address-container" v-html="currentMerchantItem.address.replace(/\n/g, '<br>') + '<br>' + currentMerchantItem.contact">

              </div>
              <div class="opening-time">
                <div>Today <span>{{isOpen==true?'Open':'Closed'}}</span></div>
                <div v-if="slots.length > 0" v-for="slot in slots">{{slot.fromString}}~{{slot.toString}}</div>
                <div v-else>Closed</div>
              </div>
            </div>

            <div class="row text-style-1" style="min-height:65px;background-color: #efeff6;">


              <div class="col-8" v-if="checkIfOpen() == false" >
                <div class="elapsed-text-box" style="background: #feeb48">
                  Closed
                </div>
              </div>
            </div>


            <div class="row" style="margin-top:10px; padding-bottom: 10px; min-height:40px;border-bottom:1px solid #efeff6;" v-if="currentMerchantItem != false && currentMerchantItem.categories != undefined">
              <div class="col-12 hide-scrollbar horizontal-scroll-container" id="cat-container" style="overflow-x: scroll;scroll-behavior: smooth;-webkit-overflow-scrolling: touch;">
                <ul class="nav nav-tabs" >
                  <li v-for="(cat, index) in currentMerchantItem.categories" ><a class="button-outlined-container button-text cat-button" v-bind:class="{'active': index == 0}" :id="'cat-'+cat.id" v-on:click="onCatClicked(index)" data-toggle="tab" :href="'#cat-' + cat.id">{{cat.name}}</a></li>
                </ul>
              </div>
            </div>

          </div>



          <div class="container" style="padding-top:310px;" id="menu-list-container">
            <div class="row" v-if="currentMerchantItem != false && currentMerchantItem.categories != undefined">
              <div class="col-12">
                <div class="tab-content">
                  <div v-for="(cat, index) in currentMerchantItem.categories" :id="'cat-menu-container-' + cat.id">
                    <!--                  <div v-for="(cat, index) in currentMerchantItem.categories" :id="'cat-menu-container-' + cat.id">-->

                    <div class="menu-item-card" v-for="menu in cat.list" v-bind:class="{'sold-out-item': menu.soldOut == 1}" v-on:click="selectMenuAnim(menu)">
                      <div class="merchant-card-wrapper">

                        <div class="menu-card-info" style="position: relative;">
                          <div class="menu-card-title"><span v-if="menu.public_name == null || menu.public_name.length == 0">{{menu.name}}</span><span v-else>{{menu.public_name}}</span></div>
                          <p class="menu-item-description" style="margin-top:10px;" v-if="menu.description != null">{{menu.description}}</p>
                          <div class="menu-item-price" style="margin-top:10px;">
                            <span v-html="promotionEligable(menu)"></span>
                            <span v-if="menu.soldOut == 1" style="color:#FF795C;"><br>Sold Out</span>
                            <span v-if="menu.soldOut == 0 && menu.pricePoints > 0 &&
                            (order == false || order.pointsUsed == 0) &&
                            userPoint != undefined && userPoint != false && userPoint.balance > 0 && userPoint.balance > menu.pricePoints">
                              or {{menu.pricePoints}} {{points.unitTitle}}s
                            </span>
                          </div>

<!--                          <div v-if="getMenuAmount(menu) != ''" class="menu-item-amount">{{getMenuAmount(menu)}}</div>-->
                        </div>
                        <div class="menu-card-image" style="margin-top: 10px;"  v-bind:style="{backgroundImage: 'url(' + menu.imgs[0] + ')'}"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Bottom
            :item="currentMerchantItem">

          </Bottom>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
    import {Slider, SliderItem} from "vue-easy-slider";
    import Bottom from "./Bottom";
    import {getMerchant, getMerchantMenus} from "../api/borium";
    import EventBus from "../api/event-bus";
    import {millisToDate, millisToHM} from "../api/utils";

    export default {
        name: "NailArt",
        data() {
          return {
            animDuration: 300,

            merchantId:0,
            tableItem: false,
            currentMerchantItem: false, //매장정보
            images:[],

            isLoading:false,
            loadingMessage:'',

            slots:[],
            isOpen:false,
          }
        },
        components: {
          Slider,
          SliderItem,
          Bottom,
        },
        created() {
          this.updatePage();
        },
        mounted() {
        },
        methods: {
          updatePage: function() {
            if(this.$route.params.hasOwnProperty('id') || this.$route.query.hasOwnProperty('id')) {
              if(this.$route.params.hasOwnProperty('id')) {
                // console.log("Params " + this.$route.params.id);
                this.$data.merchantId = this.$route.params.id;
              } else if(this.$route.query.hasOwnProperty('id')) {
                this.$data.merchantId = this.$route.query.id;
                // console.log("Query " + this.$route.query.id);
              }


              let self = this;
              getMerchant(this.$data.merchantId)
                .then(function(data) {
                  // let nowTime = new Date().getTime();
                  // console.log("response took " + (nowTime - fromTime));
                  if(data.success == true) {
                    // if(data.table != undefined) {
                    //   self.$data.tableItem = data.table;
                    // }
                    self.merchantSelected(data.item);
                    // console.log("call gethistory")

                  } else {
                    // console.log("Failed to get merchant " + data.message)
                  }
                })
                .catch(function(err) {
                  //console.log("err " + err)
                })
            }
          },
          /**
           * Open / Select Restaurant
           * Select -> Get menus -> Sort menus
           * @param merchant
           */
          merchantSelected: function(merchant) {
            merchant.categories = [];
            merchant.options = [];
            merchant.priceSchedules = [];
            merchant.discounts = [];
            merchant.priceOptions = [];
            this.$data.images = [];
            if (merchant.imageUrl != null && merchant.imageUrl.length > 0) {
              this.$data.images = merchant.imageUrl.split(',');
            }
            this.$data.currentMerchantItem = JSON.parse(JSON.stringify(merchant));
            EventBus.$emit("setTitle", this.$data.currentMerchantItem.title);

            this.getMenus(this.$data.currentMerchantItem.merchantId);
          },
          getMenus: function(merchantId) {
            let self = this;
            // let check1 = new Date().getTime();
            EventBus.$emit("showLoading", true, "Getting menu list");

            getMerchantMenus(merchantId, 'pos')
              .then(function(data) {
                EventBus.$emit("showLoading", false);
                // let check2 = new Date().getTime();
                // console.log("Get menu time " + (check2-check1));
                if(data.success == true) {
                  if(data.list != undefined) {
                    // console.log("Menus");
                    // console.log(data.list)
                    // let menusString = '{"list":' + data.list + '}';
                    // menus = JSON.parse(menusString);
                    // console.log()
                    self.populateMenus(data.list);
                  }
                } else {
                  // console.log("Failed to get menu list " + data.message);
                }
              })
              .catch(function(err) {
                EventBus.$emit("showLoading", false);
                // console.log(err);
                if(err.response != undefined) {
                  // console.log(err.response);
                }
              })
          },
          populateMenus: function(list) {
            this.$data.currentMerchantItem.categories = [];
            this.$data.currentMerchantItem.options = [];
            this.$data.currentMerchantItem.priceSchedules = [];
            this.$data.currentMerchantItem.discounts = [];
            this.$data.currentMerchantItem.priceOptions = [];


            for(let i = 0 ; i < list.length ; i++) {
              // console.log(list[i].name + " Type " + list[i].type + " id " + list[i].id);

              if(list[i].content != null && list[i].content.length > 0) {
                // console.log(list[i].content);
                list[i].content = JSON.parse(list[i].content);
              }
              // console.log("Passed");
              if(list[i].type === 'public_category' || list[i].type === 'category') {
                // console.log("Category " + list[i].name);
                if(list[i].isPublic == 0 && this.$data.type === 'table') {
                  continue;
                }
                if(list[i].list != null && list[i].list.length > 0) {
                  for (let j = 0; j < list[i].list.length; j++) {

                    if(list[i].list[j].content != null && list[i].list[j].content.length > 0) {
                      list[i].list[j].content = JSON.parse(list[i].list[j].content);
                    }
                    list[i].list[j].imgs = [];
                    if(list[i].list[j].image_url != null && list[i].list[j].image_url.length > 0) {
                      list[i].list[j].imgs = list[i].list[j].image_url.split(',');

                    }
                  }
                  for (let j = list[i].list.length-1; j >= 0 ; j--) {
                    if(list[i].list[j].type != 'product' || list[i].list[j].isPublic == 0) {
                      list[i].list.splice(j,1);
                    }
                  }
                }
                this.$data.currentMerchantItem.categories.push(list[i]);
              } else if(list[i].type === 'option') {
                this.$data.currentMerchantItem.options.push(list[i]);
                if(list[i].list != null && list[i].list.length > 0) {
                  for (let j = 0; j < list[i].list.length; j++) {
                    if(list[i].list[j].content != null && list[i].list[j].content.length > 0) {
                      list[i].list[j].content = JSON.parse(list[i].list[j].content);
                    }
                  }
                }
                // console.log("option " + list[i].name);
                // console.log(list[i]);

              } else if(list[i].type === 'price_schedule') {
                this.$data.currentMerchantItem.priceSchedules.push(list[i]);
              } else if(list[i].type === 'discount') {
                this.$data.currentMerchantItem.discounts.push(list[i]);
              } else if(list[i].type === 'price_option') {
                this.$data.currentMerchantItem.priceOptions.push(list[i]);
              }
            }
            // console.log("Price Schedules ");
            // console.log(this.$data.currentMerchantItem.priceSchedules);
            // Check Price Schedue
            if(this.$data.currentMerchantItem.categories.length > 0 && this.$data.currentMerchantItem.priceSchedules.length > 0) {
              for(let i = this.$data.currentMerchantItem.categories.length - 1 ; i >= 0  ; i--) {
                // console.log("Check cat PS " + this.$data.currentMerchantItem.categories[i].name);
                let content = this.$data.currentMerchantItem.categories[i].content;
                // console.log(content);
                if(content == null || content.price_schedule === undefined || content.price_schedule.length == 0) {
                  // console.log("No content price schedule");
                  continue;
                }

                let priceSchedule = content.price_schedule;
                let toShow = false;
                for(let s = 0 ; s < priceSchedule.length ; s++) {
                  if(this.isMeetPriceSchedule(priceSchedule[s].id) == true) {
                    toShow = true;
                  }
                }

                if(toShow == false) {
                  this.$data.currentMerchantItem.categories.splice(i, 1);
                }
              }
            }
            // console.log("Price Schedules Check finsished");
            if(this.$data.currentMerchantItem.categories.length > 0 && this.$data.currentMerchantItem.priceSchedules.length > 0) {
              for (let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
                // console.log("CATEGORY " + this.$data.currentMerchantItem.categories[i].name);
                if(this.$data.currentMerchantItem.categories[i].list.length > 0) {
                  for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {

                    let content = this.$data.currentMerchantItem.categories[i].list[j].content;
                    // console.log(content);
                    if(content == null || content.price_schedule === undefined || content.price_schedule.length == 0) {

                      continue;
                    }
                    // console.log("Check price schedule " + this.$data.currentMerchantItem.categories[i].list[j].name);
                    let priceSchedule = content.price_schedule;
                    for(let s = 0 ; s < priceSchedule.length ; s++) {
                      // console.log("price schedule check " + priceSchedule[s].id)
                      if(this.isMeetPriceSchedule(priceSchedule[s].id) == true) {
                        // console.log("Matching price scedule");
                        // console.log(priceSchedule[s]);
                        this.$data.currentMerchantItem.categories[i].list[j].price = priceSchedule[s].price;
                        break;
                      }
                    }
                  }
                }

              }
            }




            // console.log(this.$data.currentMerchantItem);
          },
          isMeetPriceSchedule: function(pid) {
            // console.log("isMeetPriceSchedule " + pid);
            if(this.$data.currentMerchantItem.priceSchedules.length == 0) {
              // console.log("no price schedules");
              return true;
            }
            let today = new Date();
            let day = today.getDay();
            day = day-1;
            if(day < 0) {
              day = 6;
            }
            let tableType = 'dinein';
            // if(this.$data.type == 'takeaway') {
            //   tableType = 'takeaway';
            // } else if(this.$data.type == 'delivery') {
            //   tableType = 'delivery';
            // }

            let HM = millisToHM(today.getTime());
            for(let i = 0 ; i < this.$data.currentMerchantItem.priceSchedules.length ; i++) {
              if(this.$data.currentMerchantItem.priceSchedules[i].id == pid) {
                // console.log("now check " + this.$data.currentMerchantItem.priceSchedules[i].name);
                if(this.$data.currentMerchantItem.priceSchedules[i].content.type[tableType] == undefined  || this.$data.currentMerchantItem.priceSchedules[i].content.type[tableType] == false) {
                  // console.log(this.$data.currentMerchantItem.priceSchedules[i].content.type);
                  // console.log("Canot find tableType " + tableType);
                  return false;
                }
                let days = this.$data.currentMerchantItem.priceSchedules[i].content.dayOfWeek;
                // console.log("days " + day);
                // console.log(days);
                if(days[day].apply == true) {
                  // console.log("compare time " + HM + "  range " + this.$data.currentMerchantItem.priceSchedules[i].content.from + " - " + this.$data.currentMerchantItem.priceSchedules[i].content.to);
                  if(HM >= this.$data.currentMerchantItem.priceSchedules[i].content.from && HM < this.$data.currentMerchantItem.priceSchedules[i].content.to) {
                    // console.log("day time is in range " + HM + " " + days[day].from + " - " + days[day].to);
                    return true;
                  }

                }
                // console.log("nothing matches");
                return false;

              }
            }
            // console.log("no price schedules");
            return true;
          },
          checkIfOpen: function() {
            // if(this.$data.isOpen == false) {
            //   return false;
            // }
            //
            // if(this.$data.slots.length == 0) {
            //   return false;
            // }
            //
            // let now = new Date().getTime();
            // for(let i = 0 ; i < this.$data.slots.length ; i++) {
            //   if(now > this.$data.slots[i].from && now < this.$data.slots[i].to) {
            //     return true;
            //   }
            // }
            // return false;
            return true;
          },
          promotionEligable: function(item) {
            let price = item.price;
            return "£" + Number(price).toFixed(2);
            // if(this.$data.type == 'takeaway' || this.$data.type == 'delivery') {
            //   if(item.price_ta > 0) {
            //     price = item.price_ta;
            //   }
            // }
            // if(this.$data.promotion == false) {
            //   return "£" + Number(price).toFixed(2);
            // }
            //
            // let newPrice = 0;
            // let today = millisToDate();
            // if(today >= this.$data.promotion.from && today <= this.$data.promotion.to) {
            //   let amount = this.$data.promotion.amount;
            //   if(this.$data.promotion.type == 0) {
            //     //Percent
            //     newPrice = (price*(100-amount)/100);
            //   }
            //
            // }
            //
            // if(newPrice < price) {
            //   return this.$data.promotion.title + ' ' + this.$data.promotion.amount + '%<br>' + '<del>£' + Number(price).toFixed(2) + '</del>&nbsp;&nbsp;' + "£" + Number(newPrice).toFixed(2);
            // } else {
            //   return "£" + Number(price).toFixed(2);
            // }
          },

          getPrice: function(price) {
            // let price = 0;
            let today = millisToDate();
            if(today >= this.$data.promotion.from && today <= this.$data.promotion.to) {
              let amount = this.$data.promotion.amount;
              if(this.$data.promotion.type == 0) {
                //Percent
                price = (price*(100-amount)/100);
              }

            }
            return price;
          },
          onCatClicked: function(index) {
            let catDiv = document.getElementById("cat-" + index);
            if(catDiv != null) {
              // console.log(catDiv.offsetLeft);
              let container = document.getElementById("cat-container");
              $("#cat-container").animate({scrollLeft : catDiv.offsetLeft -15}, 300);
              // container.scrollLeft = catDiv.offsetLeft -15;
            }

            let id = "cat-menu-container-" + this.$data.currentMerchantItem.categories[index].id;


            let containerDiv = document.getElementById(id);
            // console.log("offset top " + containerDiv.offsetTop);
            let diff = 0;
            if(containerDiv.offsetTop > 325) {
              diff = 150;
            }
            if(containerDiv != null) {
              $("#menu-page").animate({scrollTop : containerDiv.offsetTop + diff}, 300);
              // containerDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
              // console.log("scroll");
            }


          },
          handleScroll: function(event) {
            let restaurantPanelTop = 0 - event.srcElement.scrollTop;
            if(restaurantPanelTop < -153) {
              restaurantPanelTop = -153;
            }
            if(this.$data.preScrollPosition > -153 && restaurantPanelTop == -153) {
              $("#nav-top").removeClass("transparent-background");
            } else if(this.$data.preScrollPosition == -153 && restaurantPanelTop > -153) {
              $("#nav-top").addClass("transparent-background");
            }
            this.$data.preScrollPosition = restaurantPanelTop;
            document.getElementById("restaurant-panel").style.top = restaurantPanelTop + 'px';

            let activeCat = null;
            for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
              let catView = document.getElementById("cat-menu-container-" + this.$data.currentMerchantItem.categories[i].id);
              if(catView != null) {
                let catBtn = document.getElementById("cat-" + this.$data.currentMerchantItem.categories[i].id);
                if (this.isScrolledIntoView(catView)) {
                  if($("#cat-" + this.$data.currentMerchantItem.categories[i].id).hasClass("active") == false) {
                    catBtn.classList.add("active");
                    if (activeCat == null) {
                      activeCat = catBtn;
                    }
                  }

                } else {
                  if($("#cat-" + this.$data.currentMerchantItem.categories[i].id).hasClass("active")) {
                    catBtn.classList.remove("active");
                  }
                }
              }
            }

            if(activeCat != null) {
              // console.log("animate scroll");
              $("#cat-container").animate({scrollLeft: activeCat.offsetLeft - 15}, 100);
            }
          },
          isScrolledIntoView: function(el) {
            var rect = el.getBoundingClientRect();
            var elemTop = rect.top;
            var elemBottom = rect.bottom;

            if(elemTop <= 0 && elemBottom > window.innerHeight * 0.6) {
              return true;
            } else if(elemTop > 0 && elemTop <= window.innerHeight*0.6) {
              return true;
            } else if(elemTop >= 0 && elemBottom <= window.innerHeight) {
              return true;
            }
            return false;
          },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NailArt.vue